import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  leaveDetailsCard: {
    borderRadius: '10px',
    boxShadow: theme.customShadows.card,
    border: '1px solid',
    borderColor: theme.palette.divider,
  },
  detailIndCard: {
    borderRadius: '5px',
    boxShadow: theme.customShadows.card,
    '&:hover': {
      scale: 1.01,
      transition: 'all 0.5s ease',
    },
  },
}));
